<template>
  <div class="wrapper mt-2" v-loading="isRequestActive">
    <div v-if="listEmpty" class="text-center"><h5><span class="badge badge-secondary">There are no messages yet</span></h5></div>
    <schedule-item v-for="item in list" :model="item.model" :key="item.model.id" :settings="item.settings"></schedule-item>
  </div>
</template>

<script>
import ScheduleItem from './schedule-item';
import {addQueryParams} from "../../../libs/url";

export default {
  components: {
    ScheduleItem,
  },

  props: {
    pendingMessageIndexUrl: String,
    conversationId: Number,
  },

  data() {
    return {
      list: [],
      cancelToken: null,
      isRequestActive: false,
    };
  },

  computed: {
    /**
     * @return {Boolean}
     */
    listEmpty() {
      return _.isEmpty(this.list);
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    performLoading(exclude = null) {
      if (this.isRequestActive) {
        this.cancelToken.cancel();
      } else {
        this.isRequestActive = true;
      }

      let url = exclude ?
          addQueryParams(this.pendingMessageIndexUrl, {exclude: exclude}) :
          this.pendingMessageIndexUrl;

      this.cancelToken = axios.CancelToken.source();
      axios.get(url)
          .then(this.onLoadSuccess)
          .catch(this.onLoadError)
          .then((isCancelled) => {
            if (!isCancelled) {
              this.isRequestActive = false;
            }
          });
    },

    /**
     * @param {Object} data
     */
    onLoadSuccess({data: {data}}) {
      this.list = data;

      eventBus.$emit('schedule-list-changed', {conversationId: this.conversationId, list: data});
    },

    /**
     * @param error
     * @return {boolean}
     */
    onLoadError(error) {
      if (axios.isCancel(error)) {
        return true;
      }
    },
  },

  mounted() {
    this.performLoading();
  },

  created() {
    eventBus.$on('load-schedule-message-list', this.performLoading);
  },

  beforeDestroy() {
    eventBus.$off('load-schedule-message-list', this.performLoading);
  },
}
</script>

<style scoped>

</style>
